import { Bitcoin, Globe, ShieldCheck, Wallet, type LucideIcon } from 'lucide-react';

import { MANAGE_ROUTES } from './router';

/**
 * Staff operations tools — the `/manage` area.
 *
 * These are platform-wide, not org-scoped: they configure things shared by
 * every merchant, which is why they live outside `/org/:slug` and are gated on
 * the account-manager or superadmin role rather than org membership.
 *
 * One list, consumed by the user dropdown (and by whatever landing or nav the
 * area grows) so a new tool appears everywhere it should from a single entry.
 * Adding one is: build the page, add a route to `MANAGE_ROUTES`, add a line
 * here with a `navigation` translation key.
 */
export interface ManageNavItem {
  to: string;
  /** Key in the `navigation` i18n namespace. */
  labelKey: string;
  icon: LucideIcon;
  /**
   * Visible to partner admins as well as Tagada staff.
   *
   * Off by default: most tools here administer things across every merchant
   * and partner, which a partner admin has no business seeing. Only set it on
   * a tool where that is deliberate.
   */
  allowPartnerAdmin?: boolean;
}

export const MANAGE_NAV: ManageNavItem[] = [
  {
    to: MANAGE_ROUTES.APPLE_PAY,
    labelKey: 'managePlatformApplePay',
    icon: Wallet,
    allowPartnerAdmin: true,
  },
  {
    to: MANAGE_ROUTES.APPLE_PAY_BYOK,
    labelKey: 'manageApplePayByok',
    icon: ShieldCheck,
  },
  {
    to: MANAGE_ROUTES.APPLE_PAY_DOMAINS,
    labelKey: 'manageApplePayDomains',
    icon: Globe,
  },
  {
    to: MANAGE_ROUTES.CRYPTO_PAYMENTS,
    labelKey: 'manageCryptoPayments',
    icon: Bitcoin,
  },
];
